import React from 'react';
import { Link } from 'react-router-dom';

interface State {
  hasError: boolean;
}

class BlogErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Blog render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center" style={{ background: '#050505' }}>
          <div className="text-center px-6 py-24">
            <p className="text-5xl font-bold mb-4" style={{ color: '#14B8A6' }}>Oops</p>
            <h1 className="text-2xl font-semibold text-white mb-4">Something went wrong</h1>
            <p className="text-gray-400 mb-8 max-w-md mx-auto">
              We had trouble loading this page. Try refreshing or browse our latest insights.
            </p>
            <Link
              to="/insights"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200"
              style={{ background: '#14B8A6' }}
            >
              Browse all articles
            </Link>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default BlogErrorBoundary;
